import { generatedAPI } from '@grafana/api-clients/rtkq/legacy';

export const legacyAPI = generatedAPI.enhanceEndpoints({});

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '@grafana/api-clients/rtkq/legacy';
